import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";

type UserRole = "admin" | "coach" | "user" | null;

export const useUserRole = () => {
  const [role, setRole] = useState<UserRole>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchUserRole = async () => {
      try {
        const { data: { user } } = await supabase.auth.getUser();
        
        if (!user) {
          setRole(null);
          setLoading(false);
          return;
        }

        const { data, error } = await supabase
          .from("user_roles")
          .select("role")
          .eq("user_id", user.id);

        if (error) {
          console.error("Error fetching user role:", error);
          setRole("user");
        } else if (data && data.length > 0) {
          // If user has multiple roles, prioritize: admin > coach > user
          const roles = data.map(r => r.role);
          if (roles.includes("admin")) {
            setRole("admin");
          } else if (roles.includes("coach")) {
            setRole("coach");
          } else {
            setRole("user");
          }
        } else {
          setRole("user");
        }
      } catch (error) {
        console.error("Error in fetchUserRole:", error);
        setRole("user");
      } finally {
        setLoading(false);
      }
    };

    fetchUserRole();
  }, []);

  const isAdmin = role === "admin";
  const isCoach = role === "coach" || role === "admin";

  return { role, isAdmin, isCoach, loading };
};
